<template lang="">
    <div class="diagnosis">
        <div class="diagnosis-top">
            <div class="diagnosis-top-title">门店经营诊断</div>
            <div class="diagnosis-top-tips">
                <div class="diagnosis-top-tips-l">科学判断门店经营的</div>
                <div class="diagnosis-top-tips-r">健康状况</div>
            </div>
            <div class="diagnosis-top-nTitle">请根据门店实际情况填写</div>
            <div class="diagnosis-top-bTitle">越完备诊断越精准</div>
        </div>
        <!-- 基础信息 -->
        <div class="diagnosis-form">
            <div class="diagnosis-form-body">
                <div class="diagnosis-form-body-top">
                    <img src="@/assets/baseImg/basic.png" alt="基本信息">
                    <div class="diagnosis-form-body-top-title">基本信息</div>
                </div>
                <!-- 面积start -->
                <div class="diagnosis-form-body-int">
                    <div class="int-label">美容院面积</div>
                    <div class="int-count">
                        <van-field
                            v-model="diagnosisForm.area"
                            placeholder="请输入"
                            input-align="right"
                            error-message-align="right"
                            type="number"
                        />
                        <div class="int-count-nuit">平</div>
                    </div>
                </div>
                <!-- 面积end -->
                <!-- 房间数start -->
                <div class="diagnosis-form-body-int">
                    <div class="int-label int-label-n">房间数</div>
                    <div class="int-count ">
                        <van-field
                            v-model="diagnosisForm.roomNUm"
                            placeholder="请输入"
                            input-align="right"
                            error-message-align="right"
                            type="digit"
                        />
                        <div class="int-count-nuit">间</div>
                    </div>
                </div>
                <!-- 房间数end -->
                <!-- 床位数（工位数）start -->
                <div class="diagnosis-form-body-int">
                    <div class="int-label">床位数(工位数)</div>
                    <div class="int-count">
                        <van-field
                            v-model="diagnosisForm.bedNum"
                            placeholder="请输入"
                            input-align="right"
                            error-message-align="right"
                            type="number"
                        />
                        <div class="int-count-nuit">个</div>
                    </div>
                </div>
                <!-- 床位数（工位数）end -->
                <!-- 开业时长start -->
                <div class="diagnosis-form-body-int">
                    <div class="int-label">开业时长</div>
                    <div class="int-count">
                        <van-field
                            v-model="diagnosisForm.openingDuration"
                            placeholder="请输入"
                            input-align="right"
                            error-message-align="right"
                            type="number"
                        />
                        <div class="int-count-nuit">年</div>
                    </div>
                </div>
                <!-- 开业时长end -->
                <!-- 房租start -->
                <div class="diagnosis-form-body-int">
                    <div class="int-label">房租</div>
                    <div class="int-count">
                        <van-field
                            v-model="diagnosisForm.rent"
                            placeholder="请输入"
                            input-align="right"
                            error-message-align="right"
                            type="number"
                            style="width: 200px;"
                        />
                        <div class="int-count-nuit">万元/年</div>
                    </div>
                </div>
                <!-- 房租end -->
                <!-- 装修start -->
                <div class="diagnosis-form-body-int">
                    <div class="int-label">装修</div>
                    <div class="int-count">
                        <van-field
                            v-model="diagnosisForm.renovation"
                            placeholder="请输入"
                            input-align="right"
                            error-message-align="right"
                            type="number"
                            style="width: 240px;"
                        />
                        <div class="int-count-nuit">万元</div>
                    </div>
                </div>
                <!-- 装修end -->
                <!-- 员工数start -->
                <div class="diagnosis-form-body-int">
                    <div class="int-label int-label-n">员工数</div>
                    <div class="int-count ">
                        <van-field
                            v-model="diagnosisForm.clerkNum"
                            placeholder="请输入"
                            input-align="right"
                            error-message-align="right"
                            type="digit"
                        />
                        <div class="int-count-nuit">人</div>
                    </div>
                </div>
                <!-- 员工数end -->
                <!-- 门店位置start -->
                <div class="diagnosis-form-body-location">
                    <div class="location-label">门店位置</div>
                    <van-radio-group v-model="diagnosisForm.storeLocation" direction="horizontal">
                        <van-radio @click="storeToggle(item)" v-for="item in storeLocationList" :key="item.id" :name="item.id">{{item.name}}</van-radio>
                    </van-radio-group>
                    <div class="diagnosis-form-body-location diagnosis-form-body-n">
                        <van-radio-group v-model="otherStoreLocation" direction="horizontal">
                            <van-radio @click="storeToggle({ id: 55, name: '其他' })" :key="55" :name="'其他'">其他</van-radio>
                        </van-radio-group>
                        <!-- <div class="other-title">其他</div> -->
                        <van-field
                            v-model="addressText"
                            placeholder="请输入"
                            style="width: 240px; margin-top: 10px;"
                            
                        />
                    </div>
                </div>
                <!-- 门店位置end -->
            </div>
            <div class="diagnosis-form-body" style="margin-top: 12px;">
                <div class="diagnosis-form-body-top">
                    <img src="@/assets/baseImg/performance.png" alt="业绩信息">
                    <div class="diagnosis-form-body-top-title">业绩信息</div>
                </div>
                <!-- 常来客户start -->
                <div class="diagnosis-form-body-int" style="padding-bottom: 28px;">
                    <div class="int-label">常来客户</div>
                    <div class="int-count">
                        <van-field
                            v-model="diagnosisForm.frequentCustomers"
                            placeholder="请输入"
                            input-align="right"
                            error-message-align="right"
                            type="number"
                        />
                        <div class="int-count-nuit">人</div>
                    </div>
                    <div class="int-count-tips">(每个月到店消费频率达1至3次实际有效客户数)</div>
                </div>
                <!-- 常来客户end -->
                <!-- 平均客流量start -->
                <div class="diagnosis-form-body-int">
                    <div class="int-label int-label-n">平均客流量</div>
                    <div class="int-count ">
                        <van-field
                            v-model="diagnosisForm.flow"
                            placeholder="请输入"
                            input-align="right"
                            error-message-align="right"
                            type="digit"
                            style="width: 180px;"
                        />
                        <div class="int-count-nuit">人次/天</div>
                    </div>
                </div>
                <!-- 平均客流量end -->
                <!-- 主要客户群start -->
                <div class="diagnosis-form-body-location" style="border-bottom: 1px solid #F5F5FA;">
                    <div class="location-label" style="padding-bottom: 0;">主要客户群</div>
                    <van-checkbox-group v-model="diagnosisForm.customersAge" direction="horizontal">
                        <van-checkbox @click="ageToggle(item, index)" v-for="(item, index) in ageList" :key="item.id" :name="item.id">{{item.name}}</van-checkbox>
                    </van-checkbox-group>
                </div>
                <!-- 主要客户群end -->
                <!-- 客单价start -->
                <div class="diagnosis-form-body-int">
                    <div class="int-label">客单价</div>
                    <div class="int-count">
                        <van-field
                            v-model="diagnosisForm.customersUnitPrice"
                            placeholder="请输入"
                            input-align="right"
                            error-message-align="right"
                            type="number"
                            style="width: 240px;"
                        />
                        <div class="int-count-nuit">元</div>
                    </div>
                </div>
                <!-- 客单价end -->

                <!-- 尝试过的拓客方法start -->
                <div class="diagnosis-form-body-toker" >
                    <div class="toker-label" style="padding-bottom: 0;">尝试过的拓客方法</div>
                    <van-checkbox-group v-model="diagnosisForm.tokerMethod" direction="horizontal">
                        <van-checkbox @click="extensionFun(item)" v-for="item in extensionList" :key="item.id" :name="item.id">{{item.name}}</van-checkbox>
                    </van-checkbox-group>
                    <div class="diagnosis-form-body-toker toker-n">
                        <div class="other-title">其他</div>
                        <van-field
                            v-model="extText"
                            placeholder="请输入"
                            style="width: 230px; margin-top: 10px;"
                        />
                    </div>
                </div>
                <!-- 尝试过的拓客方法end -->

                <!-- 去年营收业绩start -->
                <div class="diagnosis-form-body-int">
                    <div class="int-label">去年营收业绩</div>
                    <div class="int-count">
                        <van-field
                            v-model="diagnosisForm.lastYearRevenue"
                            placeholder="请输入"
                            input-align="right"
                            error-message-align="right"
                            type="number"
                            style="width: 180px;"
                        />
                        <div class="int-count-nuit">万元</div>
                    </div>
                </div>
                <!-- 去年营收业绩end -->
                <!-- 去年净利润start -->
                <div class="diagnosis-form-body-int">
                    <div class="int-label int-label-n">去年净利润</div>
                    <div class="int-count">
                        <van-field
                            v-model="diagnosisForm.lastYearProfit"
                            placeholder="请输入"
                            input-align="right"
                            error-message-align="right"
                            type="number"
                            style="width: 200px;"
                        />
                        <div class="int-count-nuit">万元</div>
                    </div>
                </div>
                <!-- 去年净利润end -->
                <!-- 其他说明start -->
                <div class="diagnosis-form-body-toker" >
                    <div class="toker-label" style="padding-bottom: 0;">其他说明</div>
                    <van-field
                        v-model="diagnosisForm.remarks"
                        placeholder="请输入"
                        style="margin-top: 10px;"
                        type="textarea"
                        rows="2"
                        
                    />
                </div>
                <!-- 其他说明send  -->
            </div>
        </div>
        <div class="diagnosis-btn">
            <van-button type="primary" color="#0F50C5" size="large" @click="diagnosisFun()">立即诊断</van-button>
        </div>
        <van-overlay :show="showLoading" @click="showLoading = false">
            <div class="loading-wrapper" @click.stop>
                <img class="loading-img" src="../../assets/d-img/loadling.gif" alt="">
                <div class="loading-ititle">诊断中...</div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { ref, getCurrentInstance, onMounted } from 'vue';
import { setStore } from "../../utils/util";
import { getUUID } from '../../utils/util'
import { getAppToken } from "../../utils/getAppToken";
import { getUrlKey } from '../../utils/util'
export default {
    // 经营诊断
    name: 'DiagnosisIndex',
    setup() {
        const { proxy } = getCurrentInstance();
        // const token = ref(' eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2ODIyMzI0MTIsImp4dF9BZ2VudElkIjoxMDAyMjksImp4dF9BZ2VudE5hbWUiOiLku6PnkIbllYYt5ZCN56ewIiwianh0X0xvZ2luS2V5IjoiMTg3NzY5MTgwMzQiLCJqeHRfTG9naW5UeXBlIjoicGhvbmUiLCJqeHRfUGhvbmUiOiIxODc3NjkxODAzNCIsImp4dF9TdG9yZUlkIjoxNTM5LCJqeHRfU3RvcmVOYW1lIjoi6YCX5ZOl55qE5bqXIiwianh0X1VzZXJJZCI6MzA3MCwianh0X1VzZXJOYW1lIjoi5b6X5oiR5bqf54mpIiwianh0X1VzZXJUeXBlIjoyMywib3JpZ19pYXQiOjE2NzM1OTI0MTJ9.q-c_0gVBBtdKtzY0xJ9zbiWgsbkImYBUmxU-L7MOBmA')
        const token = ref('')
        getAppToken().then(() => {
            token.value = localStorage.getItem('appToken')
        });
        const diagnosisForm = ref({
            area: '',
            roomNUm: '',
            bedNum: '',
            openingDuration: '',
            rent: '',
            renovation: '',
            clerkNum: '',
            storeLocation: 1,
            remark: '',
            frequentCustomers: '',
            flow: '',
            customersAge: [],
            customersUnitPrice: '',
            tokerMethod: [],
            lastYearRevenue: '',
            lastYearProfit: '',
            remarks: ''
        })
        const sid = ref(getUrlKey('sid'))
        const cid = ref(getUrlKey('cid'))
        const showLoading = ref(false)
        const addressText = ref('住宅小区')
        const storeLocationList = ref([
            { id: 1, name: '住宅小区' },
            { id: 2, name: '购物商城' },
            { id: 3, name: '写字楼附近' },
        ])
        
        const ageList = ref([
            { id: 1, name: '18-25岁' },
            { id: 2, name: '26-35岁' },
            { id: 3, name: '36-50岁' },
            { id: 4, name: '50岁以上' },
        ])

        const extensionList = ref([
            { id: 1, name: '地推' },
            { id: 2, name: '老客户转介绍' },
            { id: 3, name: '异业联盟' },
            { id: 4, name: '社群运营' },
            { id: 5, name: '美团' },
            { id: 6, name: '抖音' },
        ])
        const diagnosisFun = () => {
            
            let obj = diagnosisForm.value
            
            if(!obj.area) {
                proxy.$toast.fail('请输入美容院面积');
                return
            }
            if(!obj.bedNum) {
                proxy.$toast.fail('请输入床位数');
                return
            }
            if(!obj.openingDuration) {
                proxy.$toast.fail('请输入开业时长');
                return
            }
            if(!obj.rent) {
                proxy.$toast.fail('请输入房租');
                return
            }
            if(!obj.renovation) {
                proxy.$toast.fail('请输入装修费用');
                return
            }
            if(!obj.frequentCustomers) {
                proxy.$toast.fail('请输入常来客户');
                return
            }
            if(!obj.customersUnitPrice) {
                proxy.$toast.fail('请输入客单价');
                return
            }
            if(!obj.lastYearRevenue) {
                proxy.$toast.fail('请输入去年营收业绩');
                return
            }
            showLoading.value = true
            let params = {
                area: parseFloat(obj.area),
                bedNum: parseFloat(obj.bedNum),
                openingDuration: parseFloat(obj.openingDuration),
                rent: parseFloat(obj.rent),
                renovation: parseFloat(obj.renovation),
                frequentCustomers: parseFloat(obj.frequentCustomers),
                customersUnitPrice: parseFloat(obj.customersUnitPrice),
                lastYearRevenue: parseFloat(obj.lastYearRevenue),
                clerkNum: parseFloat(obj.clerkNum),
                storeLocation: addressText.value,
                remark: obj.remarks,
                flow: parseFloat(obj.flow),
                customersAge: ageText.value,
                lastYearProfit: parseFloat(obj.lastYearProfit),
                storeId: parseFloat(sid.value),
            }
            if(extText.value) {
                let arr = extensionText.value
                arr.push(extText.value)
            }
            params.tokerMethod = extensionText.value
            proxy.$http.post(
                '/h5/diagnosis',
                params,
                { headers: { Authorization: 'Bearer ' +  token.value, 'content-type' : 'application/json; charset=utf-8' } }
            ).then(({ data: res }) => {
                if(res.success) {
                    setTimeout(() => {
                        showLoading.value = false
                        setStore('diagnosis', res.data)
                        proxy.$router.push({
                        name: 'diagnosisDetails', query: {
                            id: getUUID(),
                            sid: sid.value,
                            cid: cid.value
                        }
                    })
                    }, 4000)
                } else {
                    proxy.$toast.fail(res.errorMessage);
                }
            })
        }

        // 年龄人群
        const ageId = ref([])
        const ageText = ref([])
        const ageToggle = (item) => {
            let obj =  analysisFun(item, ageId.value, ageText.value)
            ageId.value = obj.id
            ageText.value = obj.name
        }
        // arr1 : Ids, arr2 names
        const analysisFun = (item, arr1, arr2) => {
            let id = item.id
            let name = item.name
            let arrId = arr1
            let arrText = arr2
            let idIndex = arrId.indexOf(id)
            let textIndex = arrText.indexOf(name)
            if(idIndex == -1) {
                arrId.push(id)
            } else {
                arrId.splice(idIndex, 1)
            }
            if(textIndex == -1) {
                arrText.push(name)
            } else {
                arrText.splice(textIndex, 1)
            }
            return { id: arrId, name: arrText }

        }

        // 门店地址
        const otherStoreLocation = ref('')
        const storeToggle = (item) => {
            if(55 != item.id) {
                addressText.value = item.name
                otherStoreLocation.value = 0
            } else {
                addressText.value = ''
            }
            setTimeout(() => {
                diagnosisForm.value.storeLocation = item.id
            })
        }
        const extensionId = ref([])
        const extensionText = ref([])
        const otherMethod = ref('')
        const extText = ref('')
        const extensionFun = (item) => {
            if(item.id != 66) {
                let obj = analysisFun(item, extensionId.value, extensionText.value)
                extensionText.value = obj.name
                extensionId.value = obj.id
            } else {
                otherMethod.value = item.id
                extText.value = ''
            }
            
        }
        
        


        return {
            diagnosisForm,
            storeLocationList,
            ageList,
            extensionList,
            addressText,
            extensionText,
            otherStoreLocation,
            otherMethod,
            showLoading,
            sid,
            cid,
            diagnosisFun,
            ageToggle,
            storeToggle,
            extensionFun,
        }
    },
    created() {

    },
    mounted() {
        window.document.title = '经营诊断'
    },
}
</script>

<style scoped lang="scss" src="./index.scss"></style>

